'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useAuth } from '@/components/AuthProvider'

// Drop-in replacement for a hardcoded "Sign in" link in a server-component
// marketing page header — a server component can't check auth state itself,
// so this is a small client island that can, without needing to convert the
// whole page (metadata export and all) to a client component just for one
// link. Shows "Sign in" for a logged-out visitor, "Dashboard" for a logged-in
// one, matching NavbarLogoLink's own logged-in-vs-out logic for the logo.
// Pathname detection (like AppHeader's Contact link) is self-contained here
// rather than an `active` prop, since this only has the one call site.
export function HeaderAuthLink({ className }: { className?: string }) {
  const { user, loading } = useAuth()
  const isLoginActive = usePathname() === '/login'

  if (!loading && user) {
    return <Link href="/dashboard" className={className}>Dashboard</Link>
  }

  return (
    <Link href="/login" className={isLoginActive ? 'text-white font-semibold' : className}>
      Sign in
    </Link>
  )
}
